

// symbols supported
export enum ScannerSymbolType {
    EOS,
    STRING,
    WORD,
}

/*
 * scanner provides a stream of ScannerSymbols each has a symboltype, some have a value also
 */
export class ScannerSymbol {
    type: ScannerSymbolType
    value: any

    constructor(type: ScannerSymbolType, value?: any) {
        this.type = type
        this.value = value
    }
}

// read from string
export class Reader {

    s: string
    i: number

    constructor(s: string) {
        this.s = s
        this.i = 0
    }

    readChar() {
        return this.i >= this.s.length ? null : this.s.charAt(this.i++)
    }
}

/*
 * break a string into a stream of tokens
 */
export class Scanner {
    reader: Reader
    nextChar: string


    constructor(reader: Reader) {
        this.reader = reader
        this.move()
    }

    move() {
        this.nextChar = this.reader.readChar()
    }

    nextSymbol(): ScannerSymbol {
        for (;;) {
            if (this.nextChar === null) {
                return new ScannerSymbol(ScannerSymbolType.EOS)
            }
            if (Scanner.isWordCharacter(this.nextChar)) {
                let buffer = ""
                do {
                    buffer += this.nextChar
                    this.move()
                } while (Scanner.isWordCharacter(this.nextChar))
                return new ScannerSymbol(ScannerSymbolType.WORD, buffer)
            } else if (this.nextChar === '"') {
                let buffer = ''
                this.move()
                INNERCONSUMER:
                do {
                    let c = this.nextChar
                    if (c == "\\") {
                        this.move()
                        let nc = this.nextChar
                        if (nc === 't') {
                            buffer += "\t"
                        } else if (nc === '"') {
                            buffer += "\""
                        } else if (nc === 'n') {
                            buffer += "\n"
                        } else if (nc === '\\') {
                            buffer += "\\"
                        } else if (nc === '\n' || nc === '\r') {
                            /* ignore */
                        } else {
                            buffer += this.nextChar
                        }
                        this.move()
                        continue INNERCONSUMER
                    }
                    buffer += this.nextChar
                    this.move()
                } while (this.nextChar !== null && this.nextChar !== "\"")
                this.move()
                return new ScannerSymbol(ScannerSymbolType.STRING, buffer)               
            } else if (Scanner.isWhitespace(this.nextChar)) {
                do {
                    this.move()
                } while (Scanner.isWhitespace(this.nextChar))
            }

        }
    } 

    static isWordCharacter(c: string) {
        return c && c != '"' && c != "'" && !Scanner.isWhitespace(c)
    }

    static isWhitespace(c: string) {
        if (!c) {
            return false
        }
        return c === " "
            || c === "\t"
            || c === "\r"
            || c === "\n"
            || c === "\v"
    }
}